export const MANDATORY_JUSTECH_BLOG_TOPIC_ID = 916058392
export const MANDATORY_JUS_ACADEMY_TOPIC_ID = 916794176
export const HIDDEN_TOPIC_ID = 26819755

export const BLOG_JUSTECH_BASE_URL = 'https://www.jusbrasil.com.br/blog'
export const JUS_ACADEMY_BASE_URL = 'https://ia.jusbrasil.com.br/jusia-academy'
